import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

import { ref, computed, watch, onMounted, PropType } from 'vue';
import { useRouter } from 'vue-router';
import crApi from "../service/CrApi";
import securityService from "../service/SecurityService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceSelectorComponent',
  props: {
  services: Array as PropType<string[]>,
  modelValue: Array as PropType<string[]>,
  servicesSearchText: String,
  selectAll: Boolean,
  row: { type: Number as PropType<number>, default: 3 },
  showClearBtn: Boolean,
  limit: Boolean,
  selectedServicesCheckbox: Boolean,
  deletedServices: Boolean
},
  emits: ['update:modelValue', 'update:selectAll'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const props = __props;

const emit = __emit;
const servicesSearch = ref(props.servicesSearchText || '');
const debouncedServicesSearch = ref(servicesSearch.value);
const checkAllServices = ref(props.selectAll || props.modelValue.length === (props.services ? props.services.length : 0));
const selectedServicesData = ref(props.modelValue.slice());
const isLoading = ref(false);
const offset = ref(0);
const limit = ref(25);
const services = ref([]);
const limitNum = computed(() => (props.limit ? props.row * 3 : Number.MAX_SAFE_INTEGER));
const limitServices = ref<number>(limitNum.value);

const filteredServices = computed(() => {
  return services.value.filter(service => {
    const matchSearch = service.serviceName.toLowerCase().includes(debouncedServicesSearch.value.toLowerCase());
    return matchSearch || selectedServicesData.value.includes(service.serviceId);
  });
});

onMounted(async () => {
  await loadMore({}, true, false);
  updateCheckAllState();
});

watch(servicesSearch, (newSearch) => {
  debounceSearch(newSearch);
});

watch(selectedServicesData, () => {
  updateCheckAllState();
  emit('update:modelValue', selectedServicesData.value);
});

let debounceTimeout: ReturnType<typeof setTimeout>;
function debounceSearch(newSearch: string) {
  clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(() => {
    debouncedServicesSearch.value = newSearch;
    offset.value = 0;
    services.value = [];
    loadMore({}, false, true);
  }, 1000);
}

function goEditServicePage(serviceId) {
  router.push({ path: `/account/services/${serviceId}/type/` });
}

function checkAll() {
  if (checkAllServices.value) {
    selectedServicesData.value = services.value.map(service => service.serviceId);
  } else {
    selectedServicesData.value = [];
  }
  emit('update:modelValue', selectedServicesData.value);
  emit('update:selectAll', checkAllServices.value);
}

function updateCheckAllState() {
  if (services.value.length > 0 && services.value.every(service => selectedServicesData.value.includes(service.serviceId))) {
    checkAllServices.value = true;
  } else {
    checkAllServices.value = false;
  }
}

async function loadMore({ done }: { done?: (arg: string) => void } = {}, firstLoad = false, search = false) {
  if (isLoading.value) {
    return;
  }
  isLoading.value = true;

  try {
    const response = await crApi.requestV2('service/retrieve/', {
      sortBy: 'servicename',
      response: 'extra',
      sortOrder: 'asc',
      website_token: securityService.getToken(),
      excludeTypes: ['webview', 'scanwedge'],
      offset: offset.value,
      limit: limit.value,
      serviceName: debouncedServicesSearch.value
    });
    if (response && response.status === 1) {
      if (search) {
        services.value.length = 0;
      }

      const newServices = response.service.filter(service => !services.value.some(s => s.serviceId === service.serviceId));
      services.value.push(...newServices);
      offset.value += response.service.length;
      limitServices.value = services.value.length;

      if (checkAllServices.value && !search) {
        newServices.forEach(service => {
          if (!selectedServicesData.value.includes(service.serviceId)) {
            selectedServicesData.value.push(service.serviceId);
          }
        });
      }

      if (firstLoad && props.modelValue.length > 0) {
        selectedServicesData.value = [...props.modelValue];
      }

      if (done) {
        done(response.service.length === 0 ? 'empty' : 'done');
      }
    }
  } catch (error) {
    console.error('Error loading services:', error);
  } finally {
    isLoading.value = false;
    updateCheckAllState();
  }
}

function serviceName(name: string) {
  return name.length > 29 ? `${name.substring(0, 29)}...` : name;
}

function clearSearch() {
  servicesSearch.value = '';
  checkAllServices.value = selectedServicesData.value.length === services.value.length;
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!

  return (_openBlock(), _createBlock(_component_v_infinite_scroll, {
    color: "black",
    mode: "manual",
    style: {"height":"100%","max-height":"400px"},
    onLoad: loadMore
  }, {
    empty: _withCtx(() => [
      _createTextVNode(" No more results ")
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_text_field, {
        class: _normalizeClass(["bg-white", __props.row === 1 ? '' : 'w-25']),
        modelValue: servicesSearch.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((servicesSearch).value = $event)),
        placeholder: "Type to begin filtering...",
        clearable: "",
        "onClick:clear": clearSearch,
        density: "compact",
        variant: "outlined",
        "hide-details": ""
      }, null, 8 /* PROPS */, ["class", "modelValue"]),
      _createVNode(_component_v_checkbox, {
        modelValue: checkAllServices.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkAllServices).value = $event)),
        onChange: checkAll,
        label: "Select All",
        density: "compact"
      }, null, 8 /* PROPS */, ["modelValue"]),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredServices.value, (service, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: service.serviceId
            }, [
              (Number(index) < limitServices.value)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    md: __props.row === 1 ? 12 : 3,
                    class: "py-0",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_checkbox, {
                        density: "compact",
                        label: serviceName(service.serviceName),
                        modelValue: selectedServicesData.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedServicesData).value = $event)),
                        value: service.serviceId,
                        "hide-details": "",
                        "append-icon": "mdi-pencil-box-outline",
                        "onClick:append": ($event: any) => (goEditServicePage(service.serviceId))
                      }, null, 8 /* PROPS */, ["label", "modelValue", "value", "onClick:append"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["md"]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})